import React, { useEffect, useRef, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { getQuote } from '../../../features/quote/QuoteSlice';
import { Field } from '../../../types';
import Tooltip from '../Tooltip';

export interface AutoCompleteProps {
    field: Field;
    error?: string;
    onChange: any;
    name: string;
}
const customStyles = {
  control: (provided: any, state: any) => ({
    ...provided,
    height: 56,
    backgroundColor: 'white',
    border: 'none',
    boxShadow: state.isSelected || state.isFocused ? '0 0 0 0.25rem rgb(13 110 253 / 25%);' : '',
    borderRadius: '16px',
    marginBottom: '1rem !important',
  }),
  indicatorSeparator: (provided: any) => ({
    ...provided,
    backgroundColor: '#FFF',
  }),
  placeholder: (provided: any) => ({
    ...provided,
    color: '#212529',
  }),
  valueContainer: (provided: any) => ({
    ...provided,
    paddingLeft: '1rem',
    height: 56,
  }),
  input: (provided: any) => ({
    ...provided,
    height: 56,
    position: 'absolute',
  }),
  svg: (provided: any) => ({
    ...provided,
    display: 'none',
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    width: '100%',
    borderBottom: '1px dotted black',
    color: state.selectProps.menuColor,
    padding: 20,
    zIndex: 200,
  }),
  indicatorsContainer: (provided: any, state: any) => ({
    ...provided,
    backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e")',
    backgroundPosition: 'right 0.75rem center',
    backgroundSize: '16px 12px',
    backgroundRepeat: 'no-repeat',
    color: '#000',
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    visibility: 'hidden',
  }),
};
function AutoCompleteInput(props: AutoCompleteProps) {
  const {
    error, field, onChange, name,
  } = props;
  const [loadedFieldOptions, setFieldOptions] = useState(field.data);
  const [selectedOption, setSelectedOption] = useState(false);

  const {
    data, fieldOptions,
  } = useSelector(getQuote);

  useEffect(() => {
    if (fieldOptions[field.formId]) {
      const selected = data[field.formId] || field.value
        ? fieldOptions[field.formId]
          .find((option: any) => {
            if (data[field.formId]) {
              return option.value === data[field.formId];
            }
            return option.value === field.value;
          }) : false;
      if (selected) {
        setSelectedOption(selected);
      } else {
        setSelectedOption(false);
      }
    }
  }, [fieldOptions[field.formId]]);

  useEffect(() => {
    if (field.loadData) {
      fetch(field.loadData.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: new URLSearchParams(field.loadData.body),
      })
        .then((response) => response.json())
        .then((options) => {
          setFieldOptions(options);
          if (options && options.length > 0) {
            options.forEach((option: any) => {
              if (option.value === data[field.formId]) {
                setSelectedOption(option);
              }
            });
          }
        });
    }
  }, [field.loadData]);

  const handleSelectChange = (value: any) => {
    setSelectedOption(value);
    onChange(value.value);
  };

  return (
    <div className={`mb-4 form-card p-4 ${error ? 'error' : ''}`}>
      <label htmlFor={field.id} className="form-label my-2">
        {field.label}
        {field.required
                    && <span className="ms-2 d-inline-block asterix">*</span>}
      </label>
      <Select
        styles={customStyles}
        onChange={handleSelectChange}
        value={selectedOption}
        placeholder="Select an answer..."
        getOptionLabel={(option: any) => (fieldOptions[field.formId] ? option.text : option.data)}
        getOptionValue={(option: any) => option.value}
        options={fieldOptions[field.formId] || loadedFieldOptions}
      />

      <div className="form-card-footer d-flex  justify-content-end">
        {
                    error
                    && <small className="error ">{error}</small>
                }
        {field.tooltip && <Tooltip tooltipText={field.tooltip} />}
      </div>
    </div>
  );
}
AutoCompleteInput.defaultProps = {
  error: false,
};
export default AutoCompleteInput;
